import { Transition, Variants } from 'framer-motion'

const menuTransition: Transition = {
  type: 'spring',
  damping: 15,
}

export const nativeMenuItemLabelAnimationVariants: Variants = {
  init: {
    opacity: 0,
    x: -15,
    transition: menuTransition,
  },
  maximize: {
    opacity: 1,
    x: 0,
    transition: menuTransition,
  },
  minimize: {
    opacity: 0,
    x: -15,
    transition: menuTransition,
  },
  exit: {},
}

export const nativeMenuItemIconAnimationVariants: Variants = {
  init: {
    marginRight: '0px',
    marginLeft: '4px',
    transition: menuTransition,
  },
  maximize: {
    marginRight: '16px',
    marginLeft: '0px',
    transition: menuTransition,
  },
  minimize: {
    marginRight: '0px',
    marginLeft: '4px',
    transition: menuTransition,
  },
  exit: {},
}
